/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FaxProfileResponseDto
 */
export interface FaxProfileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof FaxProfileResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FaxProfileResponseDto
     */
    practiceId: string;
    /**
     * 
     * @type {string}
     * @memberof FaxProfileResponseDto
     */
    sinchServiceId: string;
    /**
     * 
     * @type {string}
     * @memberof FaxProfileResponseDto
     */
    faxNumber: string;
    /**
     * 
     * @type {string}
     * @memberof FaxProfileResponseDto
     */
    status: FaxProfileResponseDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof FaxProfileResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof FaxProfileResponseDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const FaxProfileResponseDtoStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    Suspended: 'suspended',
    Retired: 'retired'
} as const;
export type FaxProfileResponseDtoStatusEnum = typeof FaxProfileResponseDtoStatusEnum[keyof typeof FaxProfileResponseDtoStatusEnum];


/**
 * Check if a given object implements the FaxProfileResponseDto interface.
 */
export function instanceOfFaxProfileResponseDto(value: object): value is FaxProfileResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('practiceId' in value) || value['practiceId'] === undefined) return false;
    if (!('sinchServiceId' in value) || value['sinchServiceId'] === undefined) return false;
    if (!('faxNumber' in value) || value['faxNumber'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function FaxProfileResponseDtoFromJSON(json: any): FaxProfileResponseDto {
    return FaxProfileResponseDtoFromJSONTyped(json, false);
}

export function FaxProfileResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxProfileResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'practiceId': json['practiceId'],
        'sinchServiceId': json['sinchServiceId'],
        'faxNumber': json['faxNumber'],
        'status': json['status'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function FaxProfileResponseDtoToJSON(json: any): FaxProfileResponseDto {
    return FaxProfileResponseDtoToJSONTyped(json, false);
}

export function FaxProfileResponseDtoToJSONTyped(value?: FaxProfileResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'practiceId': value['practiceId'],
        'sinchServiceId': value['sinchServiceId'],
        'faxNumber': value['faxNumber'],
        'status': value['status'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

